import { metaAccount, metaPublic } from '@/router/meta-config'
import { redirectIfAuthenticated } from '@/router/middleware'

export default [
  {
    path: '/',
    name: 'page-index',
    component: () => import('@/pages/dashboard'),
    meta: metaAccount
  },
  {
    path: '/sign-in',
    name: 'page-sign-in',
    component: () => import('@/pages/sign-in'),
    beforeEnter: redirectIfAuthenticated,
    meta: metaPublic
  }
]
